import Box from '@mui/material/Box';
import { motion } from 'framer-motion';
import { ReactNode, useMemo } from 'react';

export const drawerWidth = 260;

type SidebarProps = {
    children: ReactNode;
    open: boolean;
    side: 'left' | 'right';
    width?: number;
};

export default function Sidebar({
    children,
    open,
    side = 'left',
    width = drawerWidth,
}: SidebarProps) {
    const variants = useMemo(() => {
        if (side === 'left') {
            return {
                open: {
                    x: 0,
                    width,
                    transition: { ease: 'linear', duration: 0.1 },
                },
                closed: {
                    x: -width,
                    width: 0,
                    transition: { ease: 'linear', duration: 0.1 },
                },
            };
        }
        return {
            open: {
                x: 0,
                width,
                transition: { ease: 'linear', duration: 0.1 },
            },
            closed: {
                x: width,
                width: 0,
                transition: { ease: 'linear', duration: 0.1 },
            },
        };
    }, [side, width]);

    return (
        <Box
            zIndex={999}
            variants={variants}
            animate={open ? 'open' : 'closed'}
            initial={open ? 'open' : 'closed'}
            component={motion.div}
            sx={{
                position: 'relative',
                width,
                top: 0,
                left: 0,
                borderLeft: (theme) =>
                    side === 'right' ? `1px solid ${theme.palette.divider}` : 0,
            }}
        >
            <Box width={width} height="100%">
                {children}
            </Box>
        </Box>
    );
}
